module.exports = __webpack_public_path__ + "img/1534201114.490058a3.jpg";